import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import FullScreen from '@blade/common/components/full-screen.vue';
import AuthItem from '@blade/common/components/auth/auth-item.vue';
import VisitorGroup from './components/group.vue';
import Visitor from './components/visitor.vue';
let default_1 = class extends Vue {
    activeName = 'GROUP';
    keyword = '';
    libId = [];
    handleTabChange(val, event) {
        if (val?.name === 'GROUP') {
            this.libId = [];
        }
        console.log('val:', this.activeName);
        this.$router.push({ path: '/traffic/staff/visitor', query: { group: val?.name || 'GROUP' } });
    }
    handleSearch() {
        console.log('search:', this.keyword);
        if (this.activeName === 'GROUP') {
            this.$refs.group.handleSearch(this.keyword);
        }
        else {
            this.$refs.staff.handleSearch(this.keyword);
        }
    }
    handleClear() {
        this.keyword = '';
    }
    mounted() {
        const { query } = this.$route;
        if (query) {
            this.activeName = query.group || 'GROUP';
        }
    }
    handleClick(libId) {
        this.libId = [libId];
        this.activeName = 'STAFF';
        this.handleTabChange({ name: 'STAFF' }, {});
    }
};
default_1 = __decorate([
    Component({
        name: 'VisitorMain',
        components: {
            FullScreen,
            AuthItem,
            'visitor-group': VisitorGroup,
            visitor: Visitor,
        },
        i18n: {
            messages: {
                'en-us': {
                    searchHold: 'Name/ID/Group Name',
                    group: 'Group',
                    staff: 'User',
                },
                zh: {
                    searchHold: '姓名/ID/人员组名称',
                    group: '人员组',
                    staff: '人员',
                },
            },
        },
    })
], default_1);
export default default_1;
